// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__iHeWl","iconWrapper":"styles_iconWrapper__yt--F","button":"styles_button__rN584"};